import type { RouterConfig } from '@nuxt/schema';

import signedInUser from './utils/CheckSignedInUser';

export default <RouterConfig>{
  routes: (_routes) => [
    {
      name: 'Registry Landing Page',
      path: '/registry',
      component: () => import('~/pages/RegistryCommonLandingView.vue'),
    },
    {
      name: 'Search Registry',
      path: '/registry/search',
      component: () => import(/* webpackChunkName: "SearchRegistryView" */ '~/pages/SearchRegistryView.vue'),
    },
    {
      name: 'Wedding Registry',
      path: '/registry/wedding/create',
      beforeEnter: signedInUser,
      component: () => import(/* webpackChunkName: "CreateRegistry" */ '~/pages/CreateRegistryView.vue'),
    },
    {
      name: 'Gift Giver Registry',
      path: '/registry/:registrantFirstName-:registrantLastName-:coregistrantFirstName?-:coregistrantLastName?/:registryId',
      alias: ['/registry/:registrantFirstName-:registrantLastName/:registryId', '/registry/-/:registryId'],
      component: () => import(/* webpackChunkName: "GiftGiverRegistryView" */ '~/pages/GiftGiverRegistryView.vue'),
    },
    {
      name: 'Registrant View',
      path: '/registry/manage',
      beforeEnter: signedInUser,
      component: () => import(/* webpackChunkName: "RegistrantView" */ '~/pages/RegistrantView.vue'),
    },
    {
      name: 'Registry Settings',
      path: '/registry/settings',
      beforeEnter: signedInUser,
      component: () => import(/* webpackChunkName: "RegistrySettingsView" */ '~/pages/RegistrySettingsView.vue'),
    },
    {
      name: 'Link Registry',
      path: '/registry/link',
      beforeEnter: signedInUser,
      component: () => import(/* webpackChunkName: "LinkRegistryPage" */ '~/pages/LinkRegistryView.vue'),
    },
    {
      name: 'Baby Registry',
      path: '/registry/baby/create',
      beforeEnter: signedInUser,
      component: () => import(/* webpackChunkName: "CreateRegistry" */ '~/pages/CreateRegistryView.vue'),
    },
    {
      name: 'Registry Bonus Gifts',
      path: '/registry/wedding/bonusgifts',
      component: () => import(/* webpackChunkName: "CreateRegistry" */ '~/pages/BonusGiftsView.vue'),
    },
    {
      name: 'Baby Landing Page',
      path: '/registry/baby',
      component: () => import(/* webpackChunkName: "RegistryLandingPageView" */ '~/pages/RegistryOccasionLandingView.vue'),
    },
    {
      name: 'Wedding Landing Page',
      path: '/registry/wedding',
      component: () => import(/* webpackChunkName: "RegistryLandingPageView" */ '~/pages/RegistryOccasionLandingView.vue'),
    },
    {
      path: '/registry/:catchAll(.*)',
      redirect: '/registry',
    },
  ],
};
